export default () => (
  <svg
    width="22"
    height="17"
    viewBox="0 0 22 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.10001 10.7667C5.72593 10.7667 6.23334 10.2593 6.23334 9.63335C6.23334 9.00741 5.72593 8.5 5.10001 8.5C4.47409 8.5 3.96667 9.00741 3.96667 9.63335C3.96667 10.2593 4.47409 10.7667 5.10001 10.7667Z"
      fill="currentColor"
    />
    <path
      d="M16.4333 10.7667C17.0592 10.7667 17.5666 10.2593 17.5666 9.63335C17.5666 9.00741 17.0592 8.5 16.4333 8.5C15.8073 8.5 15.2999 9.00741 15.2999 9.63335C15.2999 10.2593 15.8073 10.7667 16.4333 10.7667Z"
      fill="currentColor"
    />
    <path
      d="M7.93335 9.91642C7.93335 9.44697 8.27931 9.06641 8.70607 9.06641H12.8273C13.2541 9.06641 13.6 9.44697 13.6 9.91642C13.6 10.3858 13.2541 10.7664 12.8273 10.7664H8.70607C8.27931 10.7664 7.93335 10.3858 7.93335 9.91642Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.921 1.89597C4.38218 0.750881 5.49882 0 6.74056 0H14.7928C16.0345 0 17.1512 0.750857 17.6123 1.89597L18.9627 5.24889C19.0006 5.34303 19.0272 5.43802 19.0434 5.53265C20.4596 5.78843 21.5333 7.01968 21.5333 8.5V15.629C21.5333 16.3862 20.9153 17 20.153 17H17.9444C17.1821 17 16.5641 16.3862 16.5641 15.629V13.7097H4.96922V15.629C4.96922 16.3862 4.35124 17 3.58889 17H1.38033C0.618 17 0 16.3862 0 15.629V8.5C0 7.03233 1.05547 5.80949 2.45365 5.53943L3.921 1.89597ZM1.65642 13.7097H3.31283V15.3548H1.65642V13.7097ZM19.8769 8.5V12.0645H1.65642V8.5C1.65642 7.74284 2.27442 7.12902 3.03675 7.12902H18.4966C19.2589 7.12902 19.8769 7.74284 19.8769 8.5ZM18.2205 13.7097V15.3548H19.8769V13.7097H18.2205ZM16.0744 2.50696L17.2733 5.48387H4.26004L5.45894 2.50696C5.66855 1.98647 6.17612 1.64515 6.74056 1.64515H14.7928C15.3572 1.64515 15.8648 1.98647 16.0744 2.50696Z"
      fill="currentColor"
    />
  </svg>
);
